import { Select } from "antd";
import { useCategorySelectOptions } from "components/UI/Selects/CategorySelectSearchable/useCategorySelectOptions.ts";
import {
    SearchableSelect,
    SearchableSelectWrapperProps,
} from "components/UI/Selects/SearchableSelect/SearchableSelect.tsx";

interface CategorySelectSearchableProps extends SearchableSelectWrapperProps {
    useNameAsValue?: boolean;
}

export const CategorySelectSearchable = ({ useNameAsValue = false, ...props }: CategorySelectSearchableProps) => {
    const hookResult = useCategorySelectOptions({ useNameAsValue });

    if (hookResult.loading && !hookResult.options.length) {
        return <Select {...props} loading disabled size={props.size ?? "middle"} />;
    }

    return (
        <SearchableSelect
            hookResult={hookResult}
            translationNamespace="forms.general-fields.category"
            {...props}
            size={props.size ?? "middle"}
        />
    );
};
